export const FETCH_EQUESTRIAN_LISTING = "FETCH_EQUESTRIAN_LISTING";
export const FETCH_EQUESTRIAN_LISTING_BEGIN = "FETCH_EQUESTRIAN_LISTING_BEGIN";
export const FETCH_EQUESTRIAN_LISTING_SUCCESS = "FETCH_EQUESTRIAN_LISTING_SUCCESS";
export const FETCH_EQUESTRIAN_LISTING_ERROR = "FETCH_EQUESTRIAN_LISTING_ERROR";
